module.exports = __webpack_public_path__ + "img/fd3d083.jpg";